import moment from 'moment';

export default {
    data() {
        return {
            changeInputCount: 0,
            click: true,
        }
    },
    methods: {
        // 返回上一级弹窗
        backAlert(to, from, next, defaultCount = 0, nextState = false) {
            if(location.href.includes("type=view"))return next()
            return new Promise((resolve, reject) => {
                if (this.changeInputCount > defaultCount) {
                    this.confirmAlert(
                        () => {
                            reject('success')
                            next(nextState)
                        }, () => {
                            reject('error')
                            next()
                        })
                } else {
                    resolve()
                    next()
                }
            })

        },
        // 点击右边按钮的时候弹窗
        clickAlert(defaultCount = 0) {
            return new Promise((resolve, reject) => {
                if (this.changeInputCount > defaultCount) {
                    this.confirmAlert(
                        () => {
                            reject('success')
                        }, () => {
                            reject('error')
                        })
                } else {
                    resolve()
                }
            })
        },
        // 弹窗
        confirmAlert(acceptCb, rejectCb) {
            this.$confirm.require({
                message: this.$t('MasterdataSampletype.pageChangeSave'),
                header: this.$t('提示'),
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    acceptCb()
                },
                reject: () => {
                    rejectCb()
                }
            });
        },
        // 表格按钮展示
        getBtnList(text, defaultBtn = {}) {
            var defuleNewBtn = {
                search: true,
                view: false,
                export :true,
                clear :true,
                saveShowingColumns :true,
            }
            Object.assign(defuleNewBtn, defaultBtn)
            // console.log(text, defaultBtn)
            var defaultBtnList = []
            for (const key in defuleNewBtn) {
                if (Object.hasOwnProperty.call(defuleNewBtn, key)) {
                    let element = defuleNewBtn[key];
                    if (element) defaultBtnList.push(key)
                }
            }
            let btnList = JSON.parse(sessionStorage.getItem('btnList') || '{}')
            var arr = []
            arr = arr.concat(defaultBtnList)
            // console.log(defaultBtnList,'defaultBtnList')
            btnList?.children?.forEach(item => {
                let [pageName, type] = item.perms.split(":")
                if (pageName == text) {
                    arr.push(type)
                }
            })
            // console.log(btnList, text, arr)
            return arr
        },
        showBtn(text) {
            let btnList = JSON.parse(sessionStorage.getItem('btnList') || '{}')
            let findText = btnList.children.find((item) => item.perms == text)
            // console.log(!!findText, 'btnList')
            return !!findText
        },
        menuDataBtn() {
            let btnList = JSON.parse(sessionStorage.getItem('btnList') || '{}')
            var menuDataAttr = btnList.children.filter(el => el.perms.includes("menuData")
                ||el.perms.includes("liebiaoye:edit")
                ||el.perms.includes("liebiaoye:view"))
            var result = menuDataAttr.map(el => {
                var [btnfrom, type] = el.perms.split(":")
                if(btnfrom == "liebiaoye" && type == "edit"){
                    return "save"
                }else if(btnfrom == "liebiaoye" && type == "view"){
                    return "List"
                }else{
                    return type
                }
            })
            return result
        },
        getAttrObj(className, type = 'for', resultText = 'innerHTML') {
            let result = {}
            this.$nextTick(() => {
                document.querySelectorAll(className).forEach(el => {
                    let attr = el.getAttribute(type);
                    if (attr) {
                        result[attr] = el[resultText];
                    }
                })
            })
            return result
        },
        formCompare(objname, objcolumn, oldFormState, newFormState) {
            let arr = this.compareObjects(objcolumn, oldFormState, newFormState) // 执行上面对比两个对象的方法
            let content = ''
            arr.forEach((item) => {
                if (item.name === null || item.name === undefined || item.name === "") {

                } else {
                    item.left = item.left ? item.left : '空'
                    item.right = item.right ? item.right : '空'
                    if(item.left != item.right){
                        content += `'${item.name}' :由' ${item.left} '修改为了' ${item.right} '<br>`
                    }
                }
            })
            if (content !== "") {
                content = content.substring(0, content.length - 4)//去掉最后一个逗号
                content = objname + content
            }
            return content
        },
        listCompare(objname, columns, oldFormState, newFormState) {
            let arr = this.compareListObjects(columns, oldFormState, newFormState) // 执行上面对比两个对象的方法
            let content = []
            arr.forEach((arrvalue) => {
                let contentlog = {}
                let contentvalue = ''
                let id = ''
                let realId = ''
                arrvalue.forEach((item) => {
                    if (item.name === null || item.name === undefined || item.name === "") {

                    } else {
                        item.left = item.left ? item.left : '空'
                        item.right = item.right ? item.right : '空'
                        id = item.id
                        realId = item.realId?item.realId:''
                        contentvalue += `'${item.name}' :由' ${item.left} '修改为了' ${item.right} '<br>`
                    }
                })
                if (contentvalue !== "") {
                    contentvalue = contentvalue.substring(0, contentvalue.length - 4)//去掉最后一个逗号
                    contentvalue = objname + contentvalue
                    contentlog["realId"] = realId
                    contentlog["id"] = id
                    contentlog["contentvalue"] = contentvalue
                    content.push(contentlog)
                    console.log(contentvalue, 'contentvalue')
                }
            })
            return content
        },
        flowMathCompare(oldFormState, newFormState) {
            var result = []
            for (let oldIndex = 0; oldIndex < oldFormState.length; oldIndex++) {
                let oldItem = oldFormState[oldIndex];
                let newItem = newFormState[oldIndex];
                // console.log(oldFormState,'oldFormState')
                if (this.flowMathCompareObjects(oldItem, newItem).length > 0) {
                    result.push(...this.flowMathCompareObjects(oldItem, newItem))
                }


            }
            return result
        },


        // 定义一个比较函数
        flowMathCompareObjectsObj(obj1, obj2, objcolumn = {}, type = 1, tableConfig = {
            text: '',
            type: 1,
            // 手动设置返回数据的类型
            setType: ''
        },objname) {
            // 定义一个空数组用于存储不同的属性值
            var diff = []

            // 定义一个比较函数
            function compareObjectsObj(obj1, obj2) {
                // 定义一个空数组用于存储不同的属性值
                var diff = []

                let leftvalue;
                let rightvalue;
                if(obj2["type"] === "editor"){
                    leftvalue =  obj1["value"] == undefined ? "" : obj1["value"].length>0? obj1["value"]:""
                    rightvalue = obj2["value"] == undefined ? "" : obj2["value"].length>0? obj2["value"]:""
                }else{
                    leftvalue =  obj1["value"] == undefined ? "" : obj1["value"]
                    rightvalue = obj2["value"] == undefined ? "" : obj2["value"]
                }


                // 如果属性值不同，则将该属性和obj1和obj2的值存入diff对象
                if (leftvalue !== rightvalue) {
                    diff.push({ name: obj2["label"], left: leftvalue, right: rightvalue })
                }


                return diff
            }
            function formCompareObj(oldFormState, newFormState, objname) {
                let arr = compareObjectsObj( oldFormState, newFormState) // 执行上面对比两个对象的方法
                let content = ''
                arr.forEach((item) => {
                    if (item.name === null || item.name === undefined || item.name === "") {

                    } else {
                        item.left = item.left ? item.left : '空'
                        item.right = item.right ? item.right : '空'
                        if(item.left != item.right){
                            content += `'${item.name}' :由' ${item.left} '修改为了' ${item.right} '<br>`
                        }
                    }
                })
                if (content !== "") {
                    content = content.substring(0, content.length - 4)//去掉最后一个逗号
                    // content = objname + content
                }
                return content
            }
            var logs = ""
            for (var key=0;key<obj2.length; key++) {
                let leftvalue;
                let rightvalue;
                leftvalue = obj1[key] == undefined ? "" : obj1[key]
                rightvalue = obj2[key] == undefined ? "" : obj2[key]

                logs += formCompareObj(leftvalue, rightvalue, objname)
            }
            if(logs != ""){
                return objname + logs
            }

            return diff.filter(el => el != undefined)
        },

        // 定义一个比较函数
        flowMathCompareObjectsArrary(obj1, obj2, objcolumn = {}, type = 1, tableConfig = {
            text: '',
            /*
             * type 1  表格开关类逻辑
             * type 2  表格只有新增类型逻辑
             * type 3  表格有新增以及修改类型逻辑
             *
             * */
            type: 1,
            // 手动设置返回数据的类型
            setType: ''
        }, objname) {
            // 定义一个空数组用于存储不同的属性值
            var diff = []

            // 定义一个比较函数
            function compareListObjectsArray(obj1, obj2, tableConfig, type) {
                // 定义一个空数组用于存储不同的属性值
                var diff = []
                if(type == 2){
                    for (let i in obj2) {
                        if(obj2[i]["id"] === null
                            || obj2[i]["id"] === ""){
                            let diffvalue = []
                            for (let key in obj2[i]["type"]) {
                                let leftvalue;
                                let rightvalue;
                                // let fieldName;

                                leftvalue =  ""
                                rightvalue = obj2[i]["type"][key] === null?"":obj2[i]["type"][key]

                                let fieldName = ''

                                fieldName = tableConfig[key]

                                // 如果属性值不同，则将该属性和obj1和obj2的值存入diff对象
                                if (leftvalue !== rightvalue) {
                                    diffvalue.push({ id: obj2[i]["type"]["id"] === null?"":obj2[i]["type"]["id"],name: fieldName, left: leftvalue, right: rightvalue })
                                }
                            }
                            diff.push(diffvalue)
                        }else{
                            if(obj1.length>0){
                                if(i>obj1.length-1){
                                    let diffvalue = []
                                    for (let key in obj2[i]["type"]) {
                                        let leftvalue;
                                        let rightvalue;
                                        // let fieldName;

                                        leftvalue =  ""
                                        rightvalue = obj2[i]["type"][key] === null?"":obj2[i]["type"][key]

                                        let fieldName = ''

                                        fieldName = tableConfig[key]

                                        // 如果属性值不同，则将该属性和obj1和obj2的值存入diff对象
                                        if (leftvalue !== rightvalue) {
                                            diffvalue.push({ id: obj2[i]["type"]["id"] === null?"":obj2[i]["type"]["id"],name: fieldName, left: leftvalue, right: rightvalue })
                                        }
                                    }
                                    diff.push(diffvalue)

                                }else{
                                    for (let m in obj1) {
                                        if(obj2[i]["id"] === obj1[m]["id"]){
                                            let diffvalue = []

                                            for (let key in obj2[i]["type"]) {

                                                let leftvalue;
                                                let rightvalue;
                                                // let fieldName;
                                                if(obj1[m]){
                                                    leftvalue =  obj1[m]["type"][key] === null?"":obj1[m]["type"][key]
                                                }else{
                                                    leftvalue =  ""
                                                }
                                                rightvalue = obj2[i]["type"][key] === null?"":obj2[i]["type"][key]

                                                let fieldName = ''

                                                fieldName = tableConfig[key]

                                                console.log(leftvalue,"===================",rightvalue)

                                                // 如果属性值不同，则将该属性和obj1和obj2的值存入diff对象
                                                if (leftvalue !== rightvalue) {
                                                    diffvalue.push({ id: obj2[i]["id"] === null?"":obj2[i]["id"],name: fieldName, left: leftvalue, right: rightvalue })
                                                }
                                            }
                                            diff.push(diffvalue)
                                        }
                                    }
                                }
                            }else{
                                let diffvalue = []

                                for (let key in obj2[i]["type"]) {

                                    let leftvalue;
                                    let rightvalue;

                                    leftvalue =  ""
                                    rightvalue = obj2[i]["type"][key] === null?"":obj2[i]["type"][key]

                                    let fieldName = ''

                                    fieldName = tableConfig[key]

                                    console.log(leftvalue,"===================",rightvalue)

                                    // 如果属性值不同，则将该属性和obj1和obj2的值存入diff对象
                                    if (leftvalue !== rightvalue) {
                                        diffvalue.push({ id: obj2[i]["id"] === null?"":obj2[i]["id"],name: fieldName, left: leftvalue, right: rightvalue })
                                    }
                                }
                                diff.push(diffvalue)
                            }

                        }
                    }
                }else if(type == "6"){
                    for(let i in obj1){
                        let flag = false
                        for(let j in obj2){
                            if(obj1[i]["id"] == obj2[j]["id"]){
                                flag = true
                            }
                        }
                        if(!flag){
                            let diffvalue = []
                            for (let key in obj1[i]) {
                                let leftvalue;

                                leftvalue =  ""
                                if(obj1[i][key]!=null && Object.prototype.toString.call(obj1[i][key]) == '[object Date]'){
                                    leftvalue = obj1[i][key] === null?"":
                                        new Date(+new Date(new Date(obj1[i][key]).toJSON())
                                            + 8 * 3600 * 1000).toISOString()
                                            .replace(/T/g, ' ')
                                            .replace(/\.[\d]{3}Z/, '')
                                            .replace(" 00:00:00", '')
                                }else{
                                    leftvalue = obj1[i][key] === null?"":obj1[i][key]
                                }


                                let fieldName = ''

                                fieldName = tableConfig[key]

                                // 如果属性值不同，则将该属性和obj1和obj2的值存入diff对象
                                diffvalue.push({ id: obj1[i]["id"],name: fieldName, left: leftvalue, right: "" })
                            }
                            diff.push(diffvalue)

                        }
                    }
                }else{
                    // 定义一个空数组用于存储不同的属性值
                    for (let i in obj2) {
                        if(obj2[i]["id"] === null
                            || obj2[i]["id"] === ""){
                            let diffvalue = []
                            for (let key in obj2[i]) {
                                let leftvalue;
                                let rightvalue;
                                // let fieldName;

                                leftvalue =  ""
                                if(obj2[i][key]!=null && Object.prototype.toString.call(obj2[i][key]) == '[object Date]'){
                                    rightvalue = obj2[i][key] === null?"":
                                        new Date(+new Date(new Date(obj2[i][key]).toJSON())
                                        + 8 * 3600 * 1000).toISOString()
                                        .replace(/T/g, ' ')
                                        .replace(/\.[\d]{3}Z/, '')
                                        .replace(" 00:00:00", '')
                                }else{
                                    rightvalue = obj2[i][key] === null?"":obj2[i][key]
                                }


                                let fieldName = ''

                                if(key == "type") {
                                    fieldName = "设备类型"
                                    rightvalue = obj2[i][key].name === null?"":obj2[i][key].name
                                }else{
                                    fieldName = tableConfig[key]
                                }

                                // 如果属性值不同，则将该属性和obj1和obj2的值存入diff对象
                                if (leftvalue !== rightvalue) {
                                    diffvalue.push({ id: obj2[i]["id"] === null?"":obj2[i]["id"],name: fieldName, left: leftvalue, right: rightvalue })
                                }
                            }
                            diff.push(diffvalue)
                        }else{
                            if(obj1.length>0){
                                if(i>obj1.length-1){
                                    let diffvalue = []
                                    for (let key in obj2[i]) {
                                        let leftvalue;
                                        let rightvalue;
                                        // let fieldName;

                                        leftvalue =  ""
                                        if(obj2[i][key]!=null && (Object.prototype.toString.call(obj2[i][key]) == '[object Date]'
                                            ||(obj2[i][key].length>4 && obj2[i][key].substr(-4)=="000Z"))
                                        ){
                                            rightvalue = obj2[i][key] === null?"":
                                                new Date(+new Date(new Date(obj2[i][key]).toJSON())
                                                    + 8 * 3600 * 1000).toISOString()
                                                    .replace(/T/g, ' ')
                                                    .replace(/\.[\d]{3}Z/, '')
                                                    .replace(" 00:00:00", '')
                                        }else{
                                            rightvalue = obj2[i][key] === null?"":obj2[i][key]
                                        }


                                        let fieldName = ''

                                        if(key == "type") {
                                            fieldName = "设备类型"
                                            rightvalue = obj2[i][key].name === null?"":obj2[i][key].name
                                        }else{
                                            fieldName = tableConfig[key]
                                        }

                                        // 如果属性值不同，则将该属性和obj1和obj2的值存入diff对象
                                        if (leftvalue !== rightvalue) {
                                            diffvalue.push({ id: obj2[i]["id"] === null?"":obj2[i]["id"],name: fieldName, left: leftvalue, right: rightvalue })
                                        }
                                    }
                                    diff.push(diffvalue)
                                }else{
                                    for (let m in obj1) {
                                        if(obj2[i]["id"] === obj1[m]["id"]){
                                            let diffvalue = []
                                            for (let key in obj2[i]) {
                                                let leftvalue;
                                                let rightvalue;
                                                // let fieldName;
                                                if(obj1[m]){
                                                    // leftvalue =  obj1[m][key] === null?"":obj1[m][key]
                                                    if( obj1[m][key]!=null && (Object.prototype.toString.call(obj1[m][key]) == '[object Date]'
                                                            ||(obj1[m][key].length>4 && obj1[m][key].substr(-4)=="000Z")
                                                        )
                                                    ){
                                                        leftvalue =  obj1[m][key] === null?"":
                                                            new Date(+new Date(new Date( obj1[m][key]).toJSON())
                                                                + 8 * 3600 * 1000).toISOString()
                                                                .replace(/T/g, ' ')
                                                                .replace(/\.[\d]{3}Z/, '')
                                                                .replace(" 00:00:00", '')
                                                    }else{
                                                        leftvalue = obj1[m][key] === null?"":obj1[m][key]
                                                    }
                                                }else{
                                                    leftvalue =  ""
                                                }
                                                if( obj2[i][key]!=null && (Object.prototype.toString.call(obj2[i][key]) == '[object Date]'
                                                    ||(obj2[i][key].length>4 && obj2[i][key].substr(-4)=="000Z"))
                                                ){
                                                    rightvalue =  obj2[i][key] === null?"":
                                                        new Date(+new Date(new Date( obj2[i][key]).toJSON())
                                                            + 8 * 3600 * 1000).toISOString()
                                                            .replace(/T/g, ' ')
                                                            .replace(/\.[\d]{3}Z/, '')
                                                            .replace(" 00:00:00", '')
                                                }else{
                                                    rightvalue = obj2[i][key] === null?"":obj2[i][key]
                                                }
                                                // rightvalue = obj2[i][key] === null?"":obj2[i][key]

                                                let fieldName = ''

                                                if(key == "type") {
                                                    fieldName = "设备类型"
                                                    if(obj1[i]){
                                                        leftvalue =  obj1[m][key].name === null?"":obj1[m][key].name
                                                    }else{
                                                        leftvalue =  ""
                                                    }
                                                    rightvalue = obj2[i][key].name === null?"":obj2[i][key].name
                                                }else{
                                                    fieldName = tableConfig[key]
                                                }


                                                // 如果属性值不同，则将该属性和obj1和obj2的值存入diff对象
                                                if (leftvalue !== rightvalue) {
                                                    diffvalue.push({ id: obj2[i]["id"] === null?"":obj2[i]["id"],name: fieldName, left: leftvalue, right: rightvalue })
                                                }
                                            }
                                            diff.push(diffvalue)
                                        }
                                    }
                                }
                            }else{
                                let diffvalue = []
                                for (let key in obj2[i]) {
                                    let leftvalue;
                                    let rightvalue;
                                    // let fieldName;
                                    leftvalue =  ""
                                    if( obj2[i][key]!=null && (Object.prototype.toString.call(obj2[i][key]) == '[object Date]'
                                        ||(obj2[i][key].length>4 && obj2[i][key].substr(-4)=="000Z"))
                                    ){
                                        rightvalue =  obj2[i][key] === null?"":
                                            new Date(+new Date(new Date( obj2[i][key]).toJSON())
                                                + 8 * 3600 * 1000).toISOString()
                                                .replace(/T/g, ' ')
                                                .replace(/\.[\d]{3}Z/, '')
                                                .replace(" 00:00:00", '')
                                    }else{
                                        rightvalue = obj2[i][key] === null?"":obj2[i][key]
                                    }
                                    // rightvalue = obj2[i][key] === null?"":obj2[i][key]

                                    let fieldName = ''

                                    if(key == "type") {
                                        fieldName = "设备类型"
                                        leftvalue =  ""
                                        rightvalue = obj2[i][key].name === null?"":obj2[i][key].name
                                    }else{
                                        fieldName = tableConfig[key]
                                    }


                                    // 如果属性值不同，则将该属性和obj1和obj2的值存入diff对象
                                    if (leftvalue !== rightvalue) {
                                        diffvalue.push({ id: obj2[i]["id"] === null?"":obj2[i]["id"],name: fieldName, left: leftvalue, right: rightvalue })
                                    }
                                }
                                diff.push(diffvalue)
                            }
                        }
                    }
                }


                return diff
            }

            function listCompareArray(value, value2, tableConfig, type) {
                let arr = compareListObjectsArray(value, value2, tableConfig, type) // 执行上面对比两个对象的方法
                let content = []
                if(type == "6"){
                    arr.forEach((arrvalue) => {
                        let contentlog = {}
                        let contentvalue = ''
                        let id = ''
                        let realId = ''
                        arrvalue.forEach((item) => {
                            if (item.name === null || item.name === undefined || item.name === "") {

                            } else {
                                item.left = item.left ? item.left : '空'
                                id = item.id
                                realId = item.realId?item.realId:''
                                if(item.left != '空'){
                                    contentvalue += `${item.name}:${item.left}，`
                                }
                            }
                        })
                        if (contentvalue !== "") {
                            contentvalue = contentvalue.substring(0, contentvalue.length - 1)//去掉最后一个逗号
                            contentlog["realId"] = realId
                            contentlog["id"] = id
                            contentlog["contentvalue"] = contentvalue
                            content.push(contentlog)
                            console.log(contentvalue, 'contentvalue')
                        }
                    })
                }else{
                    arr.forEach((arrvalue) => {
                        let contentlog = {}
                        let contentvalue = ''
                        let id = ''
                        let realId = ''
                        arrvalue.forEach((item) => {
                            if (item.name === null || item.name === undefined || item.name === "") {

                            } else {
                                item.left = item.left ? item.left : '空'
                                item.right = item.right ? item.right : '空'
                                id = item.id
                                realId = item.realId?item.realId:''
                                contentvalue += `'${item.name}' :由' ${item.left} '修改为了' ${item.right} '<br>`
                            }
                        })
                        if (contentvalue !== "") {
                            contentvalue = contentvalue.substring(0, contentvalue.length - 4)//去掉最后一个逗号
                            contentvalue = objname + contentvalue
                            contentlog["realId"] = realId
                            contentlog["id"] = id
                            contentlog["contentvalue"] = contentvalue
                            content.push(contentlog)
                            console.log(contentvalue, 'contentvalue')
                        }
                    })
                }
                return content
            }

            for (var key=0;key<obj2.length; key++) {
                let leftvalue;
                let rightvalue;
                leftvalue = obj1[key] == undefined ? "" : obj1[key]
                rightvalue = obj2[key] == undefined ? "" : obj2[key]

                if(rightvalue.value.length>0){
                    if(type == 3){
                        return listCompareArray(leftvalue?.value, rightvalue.value, tableConfig, type, objname)
                    }else if(type == 2){
                        return listCompareArray(leftvalue?.value, rightvalue.value, tableConfig, type, objname)
                    }else if(type == 6){
                        let fieldconfig = {}
                        for (let i in rightvalue.propList) {
                            fieldconfig[rightvalue.propList[i].prop] = rightvalue.propList[i].label
                        }
                        return listCompareArray(leftvalue?.value, rightvalue?.value, fieldconfig, type, objname)
                    }else {
                        let fieldconfig = {}
                        for (let i in rightvalue.propList) {
                            fieldconfig[rightvalue.propList[i].prop] = rightvalue.propList[i].label
                        }
                        return listCompareArray(leftvalue?.value, rightvalue.value, fieldconfig, type, objname)
                    }

                }else{
                    if(type == 6){
                        let fieldconfig = {}
                        for (let i in rightvalue.propList) {
                            fieldconfig[rightvalue.propList[i].prop] = rightvalue.propList[i].label
                        }
                        return listCompareArray(leftvalue?.value, rightvalue?.value, fieldconfig, type, objname)
                    }
                }
            }
            return diff.filter(el => el != undefined)
        },

        // 定义一个比较函数
        flowMathCompareObjects(obj1, obj2, objcolumn = {}, type = 1, tableConfig = {
            text: '',
            /*
             * type 1  表格开关类逻辑
             * type 2  表格只有新增类型逻辑
             * type 3  表格有新增以及修改类型逻辑
             *
             * */
            type: 1,
            // 手动设置返回数据的类型
            setType: ''
        }) {
            // 定义一个空数组用于存储不同的属性值
            var diff = []
            for (let key in obj2) {
                let leftvalue;
                let rightvalue;
                leftvalue = obj1[key] == undefined ? "" : obj1[key]
                rightvalue = obj2[key] == undefined ? "" : obj2[key]



                if (Object.prototype.toString.call(rightvalue) == '[object Object]' || Object.prototype.toString.call(rightvalue) == '[object Array]') {
                    var newLeft = this.deepClone(leftvalue),
                        newRight = this.deepClone(rightvalue)
                    if (newRight.length > 0) {
                        if (tableConfig.text) {
                            if (newLeft.filter(el => el.label == tableConfig.text)) {

                                if (tableConfig.type == 1) {
                                    diff = diff.concat(this.tableSwitch(newLeft, newRight, tableConfig.text))
                                } else if (tableConfig.type == 2) {
                                    diff = diff.concat(this.tableOnleAdd(newLeft, newRight, tableConfig))
                                } else if (tableConfig.type == 3) {
                                    diff = diff.concat(this.tableAll(newLeft, newRight, tableConfig))
                                } else if (tableConfig.type == "equipment") {
                                    diff = diff.concat(this.tableAlleq(newLeft, newRight, tableConfig))
                                }
                            }
                        }
                    }
                } else if (leftvalue !== rightvalue && key == 'value' && type == 1) {
                    // console.log('第一张', obj1, obj2)
                    diff.push({ key: key, name: obj1.label, left: leftvalue, right: rightvalue, type: tableConfig.setType || obj2.type || 'input' })
                } else if (leftvalue !== rightvalue && key == 'name' && type == 1) {
                    // console.log('第儿张', obj1, obj2)
                    diff.push({ key: key, name: obj1.label, left: obj1.name, right: obj2.name, type: tableConfig.setType || obj2.type || 'input' })
                }
                else if (leftvalue !== rightvalue && Object.prototype.toString.call(rightvalue) == '[object Date]' && !tableConfig.text) {
                    // 时间
                    console.log(obj2, 'obj2', objcolumn[key])
                    diff.push({ key: key, name: objcolumn[key], left: leftvalue, right: rightvalue, type: tableConfig.setType || 'input' })
                }
                else if (leftvalue !== rightvalue && (typeof rightvalue != 'object')) {
                    console.log(obj2, 'obj2', objcolumn[key])
                    diff.push({ key: key, name: objcolumn[key], left: leftvalue, right: rightvalue, type: tableConfig.setType || 'input' })
                }
            }
            return diff.filter(el => el != undefined)
        },
        // 表格有新增以及修改类型逻辑
        tableAlleq(obj1, obj2, tableConfig = { text: '设备' }) {
            var resultArr = []
            if (obj1.filter(el => el.label == tableConfig.text).length > 0) {
                let endClearLeft = obj1.filter(el => el.label == tableConfig.text)[0].value
                let endClearRight = obj2.filter(el => el.label == tableConfig.text)[0].value
                let type = obj2.filter(el => el.label == tableConfig.text)[0].value
                //没有新增的情况
                if (endClearLeft.length == endClearRight.length) {
                    return getObj(endClearLeft, endClearRight, tableConfig.setType || type)
                } else {
                    var before = endClearRight.slice(0, endClearLeft.length)
                    var after = endClearRight.slice(endClearLeft.length, endClearRight.length)
                    // 修改
                    var change = getObj(endClearLeft, before, tableConfig.setType || type)
                    // 新增
                    var edit = after.map(el => {
                        return {
                            name: tableConfig.text + '-新增-' + el.type.name,
                            left: {},
                            right: el.type,
                            type: tableConfig.setType || type,
                            parent:el
                        }
                    })
                    return [...change, ...edit]

                }
                // 修改
                function getObj(endClearLeft, endClearRight, type) {
                    var arr = []
                    for (let index = 0; index < endClearLeft.length; index++) {
                        let leftItem = endClearLeft[index];
                        let rightItem = endClearRight[index];
                        // console.log(leftItem, rightItem)
                        console.log(rightItem,'rightItem')
                        for (const key in leftItem) {
                            if (leftItem[key] != rightItem[key] && typeof rightItem[key] != 'object') {
                                arr.push({
                                    name: tableConfig.text + '-修改-' + (typeof leftItem.type == 'string' ? JSON.parse(leftItem.type)?.name : leftItem.type?.name),
                                    left: leftItem,
                                    right: rightItem,
                                    type,
                                    key,
                                })
                            }
                        }
                    }
                    return arr
                }
                return {}
            }
        },
        // 表格有新增以及修改类型逻辑
        tableAll(obj1, obj2, tableConfig = { text: '成品框' }) {
            var resultArr = []
            if (obj1.filter(el => el.label == tableConfig.text).length > 0) {
                let endClearLeft = obj1.filter(el => el.label == tableConfig.text)[0].value
                let endClearRight = obj2.filter(el => el.label == tableConfig.text)[0].value
                let type = obj2.filter(el => el.label == tableConfig.text)[0].value
                //没有新增的情况
                if (endClearLeft.length == endClearRight.length) {
                    return getObj(endClearLeft, endClearRight, tableConfig.setType || type)
                } else {
                    var before = endClearRight.slice(0, endClearLeft.length)
                    var after = endClearRight.slice(endClearLeft.length, endClearRight.length)
                    // 修改
                    var change = getObj(endClearLeft, before, tableConfig.setType || type)
                    // 新增
                    var edit = after.map(el => {
                        return {
                            name: tableConfig.text + '-新增-' + el.type.name,
                            left: {},
                            right: el.type,
                            type: tableConfig.setType || type,
                            parent:el
                        }
                    })
                    return [...change, ...edit]

                }
                // 修改
                function getObj(endClearLeft, endClearRight, type) {
                    var arr = []
                    for (let index = 0; index < endClearLeft.length; index++) {
                        let leftItem = endClearLeft[index];
                        let rightItem = endClearRight[index];
                        // console.log(leftItem, rightItem)
                        console.log(rightItem,'rightItem')
                        for (const key in leftItem) {
                            if (leftItem[key] != rightItem[key] && typeof rightItem[key] != 'object') {
                                arr.push({
                                    name: tableConfig.text + '-修改-' + (typeof leftItem.type == 'string' ? JSON.parse(leftItem.type)?.name : leftItem.type?.name),
                                    left: leftItem,
                                    right: rightItem,
                                    type,
                                    key,
                                })
                            }
                        }
                    }
                    return arr
                }
                return {}
            }
        },
        // 表格只有新增类型逻辑
        tableOnleAdd(obj1, obj2, tableConfig = { text: '设备框' }) {
            var resultArr = []
            if (obj1.filter(el => el.label == tableConfig.text).length > 0) {
                let endClearLeft = obj1.filter(el => el.label == tableConfig.text)[0].value
                let endClearRight = obj2.filter(el => el.label == tableConfig.text)[0].value
                let type = obj2.filter(el => el.label == tableConfig.text)[0].type
                if (endClearRight && endClearRight.length > 0) {
                    var newAddMsg = endClearRight.slice(endClearLeft.length, endClearRight.length)
                    resultArr = newAddMsg.map(el => {
                        return {
                            name: tableConfig.text + '-新增-' + '-' + (typeof el.type == 'string' ? JSON.parse(el.type)?.name : el.type?.name),
                            left: {},
                            right: el.type,
                            type,
                            parent:el
                        }
                    })
                    return resultArr
                    // return {
                    //     name: tableConfig.text,
                    //     list: resultArr
                    // }
                }
                return []
            }
        },
        // 表格开关类逻辑
        tableSwitch(obj1, obj2, text = '完工清场') {
            var arr = []
            if (obj1.filter(el => el.label == text).length > 0) {
                let endClearLeft = obj1.filter(el => el.label == text)[0].value
                let endClearRight = obj2.filter(el => el.label == text)[0].value
                let type = obj2.filter(el => el.label == text)[0].type
                if (endClearRight && endClearRight.length > 0) {
                    for (let index = 0; index < endClearLeft.length; index++) {
                        let leftItem = endClearLeft[index];
                        let rightItem = endClearRight[index];
                        for (const key in leftItem) {
                            let leftValue = leftItem[key];
                            let rightValue = rightItem[key];
                            if (leftValue != rightValue) {
                                // console.log('endClearLeft==endClearRight',leftValue != rightValue)
                                // console.log({ name: text + '-' + leftItem.text, left: leftValue, right: rightValue })
                                arr.push({ name: text + '-' + leftItem.text, left: leftValue, right: rightValue, type ,key})
                            }
                        }
                    }
                }
                // return {
                //     name: text,
                //     list: arr
                // }
            }
            return arr
        },
        fileCompare(obj1, obj2) {
            if (obj1.length != obj2.length) {
                var updateLoadList = obj2.slice(obj1.length, obj2.length)

                var res = updateLoadList.map(el => {
                    return {
                        name: '上传附件-' + el.fileName,
                        left: {},
                        right: el,
                        type: 'uploading'
                    }
                })
                return res
            } else {
                return []
            }
        },
        listRemove(obj1, obj2){
            for (var i = 0; i < obj1.length; i++) {
                var index = obj1.indexOf(obj2);
                if (index > -1) {
                    obj1.splice(index, 1);
                }
            }
            return obj1
        }

    }
}